import React from "react";
import "../DashboardUnique.css";
import { toIndianCurrencyHeader } from "../../../MethodMaster/JSXComponentMothod";

export default function GrantVillageDetailHeader({ village, handleNavigateToMainTab }) {
  return (
    <div className={"govdash-villageDetailHeader"}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className="govdash-VillageHeaderCard-icon  fas fa-house-user"></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{village?.Village}</h2>
        <div className={"govdash-detailStats"}>
          {village?.GrantDetailCount && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Grant Details Count</span>
              <span className={"govdash-statValue"}>{village?.GrantDetailCount?.toLocaleString()}</span>
            </div>
          )}
          {village?.GrantYojnaCount && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Yojana Count</span>
              <span className={"govdash-statValue"}>{village?.GrantYojnaCount?.toLocaleString()}</span>
            </div>
          )}
          {!!Number(village?.TotalAmount || 0) && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Amount Disbursed</span>
              {/* <span className={'govdash-statValue'}>₹{village.TotalAmount.toLocaleString()}</span> */}
              {/* <span className={'govdash-statValue'}> {village.IsYojanaAmount ? parseFloat(village.YojanaAmount) * parseFloat(village.TotalAmount) : `₹${village.TotalAmount?.toLocaleString("en-IN")}`}</span> */}
              <span className={"govdash-statValue"}>
                {" "}
                {village.IsYojanaAmount ? parseFloat(village.YojanaAmount) * parseFloat(village.TotalAmount) : `₹${village.TotalAmount?.toLocaleString("en-IN")}`}{" "}
                {village.IsYojanaAmount
                  ? toIndianCurrencyHeader(parseFloat(village.YojanaAmount) * parseFloat(village.TotalAmount))
                  : toIndianCurrencyHeader(parseFloat(village?.TotalAmount || 0))}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
